module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAELSURBVGiB7djBEYIwEAXQjdqLIxVwTAdySCF0QOiADmyAA3aQoxU4doOXHCBEI5OElZn/bmacJX+yCwoRAAAn4S5UqpYjUUNEMqJoO/SdjtjXz47uwrkobxSxeUteilK8ng8TWSfo4Lt4isIjUVOpWqeo9Y0vQDJbhFjMwFXV4/Tzve8W3/mkUrW285ODsbNlpotJT2DoOy2I2pQ1JyR52jt5C+UM4TvdLDOQ+SRmTrkK2+eAjq3jzqQr611oCwjALTgDoR7ktvsTQABuwRlY81soBzwH/h0CcEMAbgjADQG4IQA3BOC2+wD4T8zNF8BsvYkVjLuwaCFB1Nqekbl3s4Z912q49wEAMPcGQbY5jQKi7eUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/path_config.png
// module id = aCxa
// module chunks = 3